
import Routing from './routing.js';
import Form from './form.js';
import Translations from './translation.js';
import Auth from './auth.js';
import Util from './util.js';
import API from './api.js';
import TIML from './timl.js';

Object.assign(window, { Routing, Form, Translations, Auth, Util, API, TIML });

document.addEventListener('DOMContentLoaded', () => {
    // URL must always have translation and defaults to en
    if (!Routing.isLangCodePresent()) {
        const nextPath = window.location.pathname === "/" ? "" : window.location.pathname;
        window.location.pathname = "/en" + nextPath;
        return;
    }

    // login with jwt. if no auth, limit to public pages
    let redirectPathName = Auth.loginOrRedirectWithAuthCookie();
    if (redirectPathName) {
        window.location.pathname = redirectPathName;
        return;
    }
    
    //setTranslationsUsingLanguageCode(); // set b2.translated to the chosen translations
    TIML.initialPageBuild(); // parse the route and build the html
    document.body.addEventListener('click', TIML.clickIntercepter); // to achieve SPA loading
    document.body.addEventListener('submit', Form.submitHandler);
    window.onpopstate = function () {TIML.loadPageContent();}; // for back/forward buttons
});
